<template>
  <div class="venn-diagram">
    <div id="venn" style="position: relative">
      <div id="venn-diagram-tooltip" class="venn-diagram__tooltip">
        <div class="venn-diagram__tooltip-label">{{tooltipLabel}}</div>
        <div class="venn-diagram__tooltip-count">{{tooltipSize}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import * as venn from 'venn.js'
import AttributeReport from '../features/reports/attribute/AttributeReport'

/**
 * Base component to draw Venn Diagramm
 * Used in {@link AttributeReport} page
 */
export default {
  name: 'BaseVennDiagram',
  props: {
    /**
     * @example
      config: {
        sets: [
          {sets: ['A'], label: 'Perscription', size: 4355, color: '#88e276'},
          {sets: ['B'], label: 'Sunglasses', size: 5000, color: '#ff6c6c'},
          {sets: ['A', 'B'], size: 2000}
        ]
      }
  **/
    config: {
      required: true
    }
  },
  data () {
    return {
      tooltipLabel: '',
      tooltipSize: ''
    }
  },
  mounted () {
    this.buildChart()
  },
  methods: {
    coordinateTooltip: function (tooltip) {
      tooltip
        .style('left', (d3.event.offsetX - 5) + 'px')
        .style('top', (d3.event.offsetY - 38) + 'px')
    },
    buildChart () {
      if (!this.config) {
        return
      }

      const vennDiagram = d3.select('#venn')
      const chart = venn.VennDiagram().width(500)
      vennDiagram.datum(this.config.sets).call(chart)

      const tooltip = d3.select('#venn-diagram-tooltip')
      const context = this

      vennDiagram.selectAll('path')
        .each(function (element, i) {
          if (element.color) {
            d3.select(this)
              .style('fill', element.color)
              .style('fill-opacity', 0.7)
          }
        })

      vennDiagram.selectAll('text')
        .each(function (element, i) {
          d3.select(this).remove()
        })

      // remove label from circle if label width > circle width
      // vennDiagram.selectAll('g').each(function (element, i) {
      //   const node = d3.select(this).node()
      //   const path = node.children[0]
      //   const text = node.children[1]
      //   text.setAttribute('pointer-events', 'none')
      //   if (text.getBBox().width > path.getBBox().width) {
      //     d3.select(text).remove()
      //   }
      // })

      // add listeners to all the groups to display tooltip on mouseover
      vennDiagram.selectAll('g')
        .on('mouseover', function (element, i) {
          // sort all the areas relative to the current item
          venn.sortAreas(vennDiagram, element)

          function formatNumber(num) {
            return parseInt(num).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          }

          // Display a tooltip with the current size
          tooltip.transition().duration(400).style('opacity', 0.9)
          context.coordinateTooltip(tooltip)
          context.tooltipLabel = element.label
          context.tooltipSize = formatNumber(element.size)

          // highlight the current path
          const selection = d3.select(this).transition('tooltip').duration(400)

          selection.select('path')
            .style('stroke-width', '2')
            .style('fill-opacity', element.sets.length === 1 ? 0.9 : 0.1)
            .style('stroke-opacity', 1)
            .style('stroke', '#eff2f7')
        })

        .on('mousemove', function () {
          context.coordinateTooltip(tooltip)
        })

        .on('mouseout', function (element, i) {
          tooltip.transition().duration(400).style('opacity', 0)
          const selection = d3.select(this).transition('tooltip').duration(400)
          selection.select('path')
            .style('stroke-width', '0')
            .style('fill-opacity', element.sets.length === 1 ? 0.7 : 0.0)
            .style('stroke-opacity', '0')
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .venn-diagram {

    &__tooltip {
      position: absolute;
      background-color: #fff;
      font-size: 9px;
      padding: 2px;
      border-radius: 2px;
      border: 1px solid $rfx-light-grey;
      opacity: 0;
      pointer-events: none;
      min-width: 30px;

      &-label {

      }

      &-count {

      }

      &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 20%;
        width: 0;
        height: 0;
        border-top: 8px solid #fff;
        border-right: 10px solid transparent;
      }
    }
  }
</style>
